import { render } from "./modalComment.vue?vue&type=template&id=bb471112"
import script from "./modalComment.vue?vue&type=script&lang=js"
export * from "./modalComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__